import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import smReducer from './modules/sharedmailbox/common/reducer';
import { usersAndGroups, roles } from './modules/users/reducers';
import { userDetails } from './modules/main/reducers';
import { automationsReducer } from './modules/sharedmailbox/automationsV2/redux/reducer';
import { connectorReducer } from './modules/sharedmailbox/connectors/reducers';
import { unsavedChangesReducer, modalReducer, appModesReducer, routesReducer, loaderReducer } from './modules/common/reducers';
import settingsReducer from './modules/settings/reducers';
import csatReducer from './modules/sharedmailbox/csat/reducers';
import { ugConnectorReducer } from "./modules/connectors/reducers/ugConnectorReducer"
import { smIntegrationReducer } from './modules/integrationMarketplace/reducers'
import { kbReducer } from './modules/knowledgeBase/redux/reducer';
import appDetailsReducer from './modules/developer/redux/reducer';
import { customConnectorsReducer } from './modules/custom-connectors/reducers';

/**
 * Combines all the individual reducers and creates a single data source
 */
const rootReducer = combineReducers({
  sharedMailbox: smReducer,
  form: formReducer,
  usersAndGroups: usersAndGroups,
  userDetails: userDetails,
  connectors: connectorReducer,
  ugConnector: ugConnectorReducer,
  unsavedChanges: unsavedChangesReducer,
  modal: modalReducer,
  appModes: appModesReducer,
  routes: routesReducer,
  settings: settingsReducer,
  kb: kbReducer,
  csatInfo: csatReducer,
  roles,
  loader: loaderReducer,
  integrationMarketplace: smIntegrationReducer,
  automations: automationsReducer,
  appDetails: appDetailsReducer,
  customConnectors: customConnectorsReducer
});

export default rootReducer;
